import { Component, inject, Input } from '@angular/core';
import { KpiFactorResponse } from '../../models/fuel-kpi-factor-response.model';
import { CommonModule } from '@angular/common';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslocoDirective, TranslocoService } from '@jsverse/transloco';

@Component({
  selector: 'app-factor-table',
  standalone: true,
  imports: [CommonModule, TranslocoDirective],
  templateUrl: './factor-table.component.html',
  styleUrl: './factor-table.component.scss'
})
export class FactorTableComponent {
  private readonly transloco = inject(TranslocoService);

  @Input() title: string = this.transloco.translate('fuelShared.factorTable.title');
  @Input() factors: KpiFactorResponse[] = [];
  @Input() formatters: any;
  @Input() modalFilterHeaders: any;

  sortColumn: keyof KpiFactorResponse | null = null;
  sortAsc: boolean = true;

  constructor(private readonly modalRef: NgbActiveModal) {}

  get isLoading(): boolean {
    return !this.factors || this.factors.length === 0;
  }

  sortBy(column: keyof KpiFactorResponse): void {
    if (this.sortColumn === column) {
      this.sortAsc = !this.sortAsc;
    } else {
      this.sortColumn = column;
      this.sortAsc = true;
    }

    this.factors = [...this.factors].sort((a, b) => {
      let valA = a[column];
      let valB = b[column];

      const numA = parseFloat(valA as any);
      const numB = parseFloat(valB as any);

      if (!isNaN(numA) && !isNaN(numB)) {
        return this.sortAsc ? numA - numB : numB - numA;
      }

      return this.sortAsc
        ? String(valA).localeCompare(String(valB))
        : String(valB).localeCompare(String(valA));
    });
  }

  closeModal(): void {
    this.modalRef.close();
  }
}